<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛务管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/raceManagement/team_management/team_race_management' }">团体赛赛务管理 </el-breadcrumb-item>
      <el-breadcrumb-item>总决选奖项查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-page-header @back="goBack"></el-page-header>
    <el-card style="margin-top: 15px">
      <el-tabs v-model="activeName">
        <el-tab-pane :label="levelItem.level" :name="m+''" v-for="(levelItem, m) in levels" :key="m">
          <div class="flex">
            <div class="game-card">
              <div class="tit">极速拼词 <span v-if="!loading && levelItem.info && levelItem.info.supin && levelItem.info.supin.userList">({{ levelItem.info.supin.userList.length }})</span></div>
              <div v-if="!loading && levelItem.info && levelItem.info.supin">
                <div class="data">拼对单词数量：<span>{{ levelItem.info.supin.maxScore }}</span></div>
                <div class="users">
                  <div class="user" v-for="(item, i) in levelItem.info.supin.userList" :key="i">
                    <img class="ava" :src="item.oneInchPhoto" alt="">
                    <div class="user-info">
                      <div class="t1">{{ item.userName }} {{ item.enName }} {{ item.sex === '1' ? '男' : '女' }}</div>
                      <div class="t1"></div>
                      <div class="t1">{{ formatGrade(item.grade) }}</div>
                      <div class="t1">{{ item.schoolName }}</div>
                      <div class="t1"><MaskedPhone :phone="item.phone" /></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-empty description="暂无数据" :image-size="60"></el-empty>
              </div>
            </div>
            <div class="game-card">
              <div class="tit">九宫格拼词 <span v-if="!loading && levelItem.info && levelItem.info.nine">({{ levelItem.info.nine.length }})</span></div>
              <div class="users" v-if="!loading && levelItem.info && levelItem.info.nine">
                <div v-for="(item, i) in levelItem.info.nine" :key="i">
                  <div class="data">包含9个字母单词：<span>{{ item.nineLettersSpell }}</span></div>
                  <div class="user">
                    <img class="ava" :src="item.oneInchPhoto" alt="">
                    <div class="user-info">
                      <div class="t1">{{ item.userName }} {{ item.enName }} {{ item.sex === '1' ? '男' : '女' }}</div>
                      <div class="t1"></div>
                      <div class="t1">{{ formatGrade(item.grade) }}</div>
                      <div class="t1">{{ item.schoolName }}</div>
                      <div class="t1"><MaskedPhone :phone="item.phone" /></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-empty description="暂无数据" :image-size="60"></el-empty>
              </div>
            </div>
            <div class="game-card">
              <div class="tit">词源挑战 <span v-if="!loading && levelItem.info && levelItem.info.origin">({{ levelItem.info.origin.length }})</span></div>
              <div class="users" v-if="!loading && levelItem.info && levelItem.info.origin">
                <div class="u" v-for="(item, i) in levelItem.info.origin" :key="i">
                  <div class="data">10个单词全拼对次数：<span>{{ item.originCount }}</span> 次</div>
                  <div class="user">
                    <img class="ava" :src="item.oneInchPhoto" alt="">
                    <div class="user-info">
                      <div class="t1">{{ item.userName }} {{ item.enName }} {{ item.sex === '1' ? '男' : '女' }}</div>
                      <div class="t1"></div>
                      <div class="t1">{{ formatGrade(item.grade) }}</div>
                      <div class="t1">{{ item.schoolName }}</div>
                      <div class="t1"><MaskedPhone :phone="item.phone" /></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <el-empty description="暂无数据" :image-size="60"></el-empty>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      levels: [
        { level: '小学组', key: 'primary' },
        { level: '初中组', key: 'middle' },
        { level: '高中组', key: 'high' }
      ],
      info: {},
      loading: false,
      activeName: '0'
    }
  },
  created () {
    this.getInfo()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getInfo () {
      this.loading = true
      this.$http.get('itsoReferee/startStatistics').then(res => {
        if (res.code === 200) {
          this.loading = false
          this.info = res.data
          this.levels.forEach(item => {
            item.info = res.data[item.key]
          })

          console.log(this.levels)
        }
      })
    },
    levelChange () {
      //
    },
    formatGrade (grade) {
      return this.$userInfo.getGradeData().find(item => item.dictCode === grade).dictLabel
    }
  }
}
</script>

<style scoped lang="less">
.flex{
  display: flex;
}
.game-card{
  flex: 1;
  background-color: #ecf5ff;
  padding: 12px 20px;
  margin: 0 8px;
  border-radius: 6px;
  color: #606266;
  font-size: 14px;
}
.tit{
  text-align: center;
  font-size: 14px;
  color: #5e6d82;
  font-weight: bold;
  margin-bottom: 20px;
}
.data{
  margin: 10px 0;
  color: #000;
  span{
    color: #4096ff;
    font-size: 16px;
    font-weight: bold;
  }
}
.u{
  border-bottom: 1px dashed #9b9b9c;
  padding-bottom: 10px;
  &:last-child{
    border-bottom: none;
    padding-bottom: 0;
  }
}
.user{
  display: flex;
  align-items: flex-start;
}
.ava{
  width: 60px;
  height: auto;
  margin-right: 10px;
}
.user-info{
  flex: 1;
  min-width: 0;
}
.t1{
  margin-bottom: 4px;
}
</style>
